import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';
import { Button, StateScreen } from '@cowoo/shared/ui-web';

/** 03 § 4.14 `genericError` — what a thrown render error shows instead of a white page. */
export function RouteError() {
  const { t } = useTranslation();
  // Read so React Router marks the error handled; Sentry has it already.
  useRouteError();
  return (
    <StateScreen
      title={t('common.errorTitle')}
      body={t('common.errorBody')}
      action={
        <Button size="md" onClick={() => window.location.reload()}>
          {t('common.retry')}
        </Button>
      }
    />
  );
}
